import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import {
  RESPONSIVE_BREAKPOINT,
} from 'settings'

const useMediaQuerySize = ({
  
} = {}) => {
  const theme = useTheme()
  const large = useMediaQuery(theme.breakpoints.up(RESPONSIVE_BREAKPOINT))
  return large ?
    'large' :
    'small'
}

export default useMediaQuerySize